module.exports = __webpack_public_path__ + "img/ok.8057ffc1.png";